import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { getColor } from '../../theme/colors'

/**
 * @deprecated Use ArcadeTextArea instead
 */
const TextArea = styled.textarea<{ invalid?: boolean }>`
  align-items: center;
  background-color: ${getColor('formFieldBackground')};
  border: 2px solid ${getColor('formFieldBackground')};
  border-radius: 1rem;
  box-sizing: border-box;
  caret-color: ${getColor('inputFocusBorder')};
  display: block;
  font-family: inherit;
  min-height: 10rem;
  padding: ${({ theme }) => theme.spacing.m};
  resize: none;
  width: 100%;

  ${props => props.theme.typography.input};

  :focus {
    border: 2px solid ${getColor('inputFocusBorder')};
    background: ${getColor('background')};
  }

  &::placeholder {
    color: ${getColor('disabledLabel')};
  }

  color: ${getColor('label')};

  &:focus {
    outline: none;
  }

  &:disabled {
    color: ${getColor('disabledLabel')};
    background: ${getColor('secondaryBackground')};
    border-color: ${getColor('secondaryBackground')};
  }

  ${({ invalid, theme }) =>
    invalid &&
    css`
      &,
      &:focus {
        border-color: ${theme.colors.error};
        caret-color: ${theme.colors.error};
      }
    `}
`

export default TextArea
